import { render } from "./mobile_menu_subgroup_item.vue?vue&type=template&id=021879a8&scoped=true"
import script from "./mobile_menu_subgroup_item.vue?vue&type=script&lang=js"
export * from "./mobile_menu_subgroup_item.vue?vue&type=script&lang=js"

import "./mobile_menu_subgroup_item.vue?vue&type=style&index=0&id=021879a8&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./mobile_menu_subgroup_item.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021879a8"]])

export default __exports__